<div class="log-situacao-table">
  <sgt-table [settings]="tableSettings" (scrollBottom)="onScrollBottom()">
    <tr header>
      <th
        *ngFor="let header of headers"
        >
        {{ header.label }}
      </th>
    </tr>
    <ng-container
      body
      *ngIf="logs && logs.length && !this.tableSettings.loading; else empty"
    >
      <tr *ngFor="let log of logs; trackBy: trackById">
        <td class="col-created-at">
          {{ log.createdAt | date: 'dd/MM/yyyy HH:mm' }}
        </td>
        <td class="col-usuario-created">
          <sgt-avatar
              [settings]="{
                  isShowLabelNameRight: true,
                  fullName: log.nomeUsuarioCreated,
                  imageUrl: log.avatarUrlUsuarioCreated
              }">
          </sgt-avatar>          
        </td>
        <td class="col-situacao">
          <sgt-usuario-badge-situacao
            [situacao]="log.situacao">
          </sgt-usuario-badge-situacao>
        </td>
        <td class="col-observacao" title="{{ log.observacao }}">
          {{ log.observacao }}
        </td>        
      </tr>
    </ng-container>
    <ng-template #empty>
      <ng-container empty *ngIf="!this.tableSettings.loading">
        <tr>
          <td attr.colspan="{{ headers.length}}">
            <div class="text-center p-4 text-muted">
              <p class="mb-0 mt-0">Nenhum registro encontrado.</p>
            </div>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </sgt-table>
</div>